import React from "react";
import Cookies from "js-cookie";

class TopNavigation extends React.Component {
  state = { profileOpen: false };

  toggleProfile = () => {
    this.setState(currentState => ({ profileOpen: !currentState.profileOpen }));
  };

  logout = () => {
    Cookies.remove("access_admin");
    Cookies.remove("refresh_token");
    localStorage.removeItem("menu");
    localStorage.removeItem("admin_user");
    window.location.assign("/");
  };

  render() {
    const { profileOpen } = this.state;
    const { routeName, routeDescription, onSideNavToggleClick } = this.props;

    return (
      <header className="admin-topbar">
        <div className="admin-topbar__left">
          <button
            type="button"
            className="admin-topbar__menu"
            onClick={onSideNavToggleClick}
            aria-label="Buka navigasi"
          >
            <i className="fas fa-bars" />
          </button>
          <div className="admin-topbar__title">
            <span>SPIN MANAGEMENT PORTAL / {routeName || "DASHBOARD"}</span>
            <h1>{routeName || "Dashboard"}</h1>
            {routeDescription && <p>{routeDescription}</p>}
          </div>
        </div>

        <div className="admin-topbar__actions">
          <span className="admin-topbar__system">
            <i className="fas fa-layer-group" />
            Unified workspace
          </span>
          <div className="admin-profile">
            <button
              type="button"
              className="admin-profile__trigger"
              onClick={this.toggleProfile}
              aria-expanded={profileOpen}
            >
              <span className="admin-profile__avatar">AD</span>
              <span className="admin-profile__identity">
                <strong>Administrator</strong>
                <small>Operations Administrator</small>
              </span>
              <i className={`fas fa-chevron-${profileOpen ? "up" : "down"}`} />
            </button>

            {profileOpen && (
              <div className="admin-profile__dropdown">
                <div className="admin-profile__dropdown-header">
                  <span className="admin-profile__avatar">AD</span>
                  <div><strong>Administrator</strong><small>SPIN Management Portal</small></div>
                </div>
                <div className="admin-profile__divider" />
                <button type="button" className="admin-profile__logout" onClick={this.logout}>
                  <i className="fas fa-sign-out-alt" />
                  Keluar dari akun
                </button>
              </div>
            )}
          </div>
        </div>
      </header>
    );
  }
}

export default TopNavigation;
